var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('LTable',{staticClass:"table-hover table-striped",on:{"add_user":_vm.showEditForm,"edit_trucker":_vm.showForm,"add_registration":_vm.showRegistrationForm}}),_c('add-truckers',{ref:"add_truckers"}),_c('add-registration',{ref:"add_registration"}),_c('edit-truckers',{ref:"edit_truckers"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }